import { Box, Grid2 as Grid, TextField, Typography } from '@mui/material';
import { CONSIDERATION_FIELDS } from '../constants';
import { styles } from '../styles';
import type { DealDetailsFormField, DealDetailsFormValue, DealDetailsFormValues } from '../types';
import { FormSection } from './FormSection';

type ConsiderationSectionProps = {
  values: DealDetailsFormValues;
  onChange: (field: DealDetailsFormField, value: DealDetailsFormValue) => void;
  errors?: Record<string, boolean>;
};

export const ConsiderationSection = ({
  values,
  onChange,
  errors = {},
}: ConsiderationSectionProps) => {
  return (
    <FormSection title='Consideration'>
      <Grid size={12} spacing={2} container>
        {CONSIDERATION_FIELDS.map(field => {
          return (
            <Grid size={{ sm: 12, md: 4 }} key={field.key}>
              <Box sx={{ mb: 1 }}>
                <Typography variant='subtitle2' sx={{ fontWeight: 'bold' }}>
                  {field.label}
                </Typography>
              </Box>
              <TextField
                sx={styles.textField}
                name={field.key}
                value={values[field.key] || ''}
                onChange={event => onChange(field, event.target.value)}
                fullWidth
                type='text'
                error={errors[field.key] || false}
                helperText={errors[field.key] ? 'Must be a number' : ''}
                slotProps={{
                  input: {
                    startAdornment: (
                      <Box sx={{ mr: 1, display: 'flex', alignItems: 'center' }}>US$</Box>
                    ),
                    endAdornment: (
                      <Box sx={{ ml: 1, display: 'flex', alignItems: 'center' }}>mm</Box>
                    ),
                  },
                }}
              />
            </Grid>
          );
        })}
      </Grid>
    </FormSection>
  );
};
